import React from 'react';
import { Alert, AlertProps } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';

interface ErrorSegmentProps {
    errorText: string;
}

const PlanErrorSegment: React.FC<ErrorSegmentProps & AlertProps> = ({
    errorText,
    ...alertProps
}) => {
    return (
        <Alert {...alertProps} severity="error" icon={<ErrorIcon />}>
            {errorText}
        </Alert>
    );
};

export default PlanErrorSegment;
